import { render, staticRenderFns } from "./ChatbotMessages.vue?vue&type=template&id=779c9f3f&scoped=true&"
import script from "./ChatbotMessages.vue?vue&type=script&lang=js&"
export * from "./ChatbotMessages.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotMessages.vue?vue&type=style&index=0&id=779c9f3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c9f3f",
  null
  
)

export default component.exports